/**
 * Blurs the focused text field, committing its in-progress edit through the field's own onBlur.
 * Restricted to text-entry elements so it cannot steal focus from a button, menu, or dialog.
 */
export const blurActiveField = (): void => {
    const active = document.activeElement as HTMLElement | null;
    if (!active) {
        return;
    }
    const { tagName } = active;
    const isTextEntry = tagName === 'INPUT' || tagName === 'TEXTAREA' || tagName === 'SELECT' || active.isContentEditable;
    if (isTextEntry) {
        active.blur();
    }
};
